export default "__VITE_ASSET__Cu1K3Y7R__"